// A screen that throws while rendering shows a calm way back instead of a blank page (security review 2, S6). It
// resets when the route changes, so moving on clears it.
import { Component, type ReactNode } from "react";

type Props = { resetKey: string; fallback: (reset: () => void) => ReactNode; children: ReactNode };

export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidUpdate(prev: Props): void {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }

  private reset = () => this.setState({ failed: false });

  render(): ReactNode {
    return this.state.failed ? this.props.fallback(this.reset) : this.props.children;
  }
}
